import { type HyperdxBaseConfig, setZettaClient } from '@zep/core-logger';
import { ZettaClient } from '@zep/logger/zetta';

export { sentryLoggerAdapter as Sentry } from '@zep/sentry';

export const zettaClient = new ZettaClient();
setZettaClient(zettaClient);

export const ga4Dispatch = (event: string, params: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;
  if (!window.gtag) return;
  window.gtag('event', event, params);
};

export const hyperdxLoggerConfig: HyperdxBaseConfig = {
  service: 'web-app',
  consoleCapture: false,
  debug: false,
  tracePropagationTargets: [process.env.NEXT_PUBLIC_BASE_URL || ''],
  disableReplay: true,
};

if (typeof window !== 'undefined') {
  zettaClient.initialize();
}
